import { useEffect } from "react";

import { ParceirosFooter } from "@/components/parceiros/ParceirosFooter";
import { EventoHeader } from "@/components/evento/EventoHeader";
import { EventoHero } from "@/components/evento/EventoHero";
import { EventoEscritorio } from "@/components/evento/EventoEscritorio";
import { EventoDepoimentosAssessor } from "@/components/evento/EventoDepoimentosAssessor";
import { EventoDepoimentosInvestidor } from "@/components/evento/EventoDepoimentosInvestidor";
import { EventoComoFunciona } from "@/components/evento/EventoComoFunciona";
import { EventoFAQ } from "@/components/evento/EventoFAQ";
import { EventoCTAFinal } from "@/components/evento/EventoCTAFinal";
import { EventoStickyCTA } from "@/components/evento/EventoStickyCTA";
import { useMetaPixel } from "@/hooks/useMetaPixel";

const PAGE_TITLE = "Allu Invest — Seleção de Parceiros";
const PAGE_DESC =
  "A Allu está selecionando parceiros para divulgar seus produtos de crédito estruturado securitizado. Para sócios de casas de investimentos e assessores com carteira acima de R$ 50 milhões.";

const Evento = () => {
  useMetaPixel();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") ?? "";
    metaDesc?.setAttribute("content", PAGE_DESC);

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyColor = document.body.style.color;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#0B1A0B";
    document.body.style.color = "#FFFFFF";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    return () => {
      document.title = prevTitle;
      metaDesc?.setAttribute("content", prevDesc);
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = prevBodyColor;
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#0B1A0B] text-white"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <EventoHeader />

      <main className="pb-20 md:pb-0">
        <EventoHero />
        <EventoEscritorio />
        <EventoDepoimentosAssessor />
        <EventoDepoimentosInvestidor />
        <EventoComoFunciona />
        <EventoFAQ />
        <EventoCTAFinal />
      </main>

      <EventoStickyCTA />
      <ParceirosFooter />
    </div>
  );
};

export default Evento;
